<template>
  <div class="home">
     <component
        v-for="(widget, k) in components"
        :is="widget.name"
        :data-uuid="widget.uuid"
        :data="widget"
        :key="widget.uuid"
    ></component>
	<!-- <div class="slidenav" style="top: 271.333px; display: block;">
		<div class="i i1 hover" style="display: block;">
				<span class="t">联系</br>客服</span>
				<div class="contact" style="display: block;">
						<div class="qqcon">
								<p>在线客服：<img id="closeQQ" alt="咨询客服" src="//c1.yaofangwang.net/common/images/qq-close.png"></p>
								<div class="js">
										<a href="javascript:void(0);" class="zhiCustomBtn">
												<img src="//c1.yaofangwang.net/common/images/yfwcc.png">
										</a>
								</div>
								<img alt="咨询电话" src="//c1.yaofangwang.net/common/images/qq-tel.png">
						</div>
				</div>
		</div>
		<div class="i i2">
			<span class="iconfont icon-home"></span>
				<div class="desc">
					<a class="t" href="javascript:void(0);">同店购买</a>
					<i id="tdgnum" style="display: none;"></i>
				</div>
		</div>
		<div class="i i3">
				<span class="iconfont icon-guanzhu"></span>
				<div class="desc">
					<span class="t">关注我们</span>
					<div class="gzwm">
							<div class="wxsbg"></div>
							<div>微信扫一扫<br>查药更方便</div>
							<div class="wbsbg"></div>
							<a class="gzwb" target="_blank" href="http://weibo.com/yibangyaofangwang">关注微博</a>
					</div>
				</div>
		</div>
		<div class="i i7">
			<span class="iconfont icon-erweima"></span>
				<span class="t">手机APP</span>
				<div class="app">
						<div class="appbg"></div>
						<div>手机查药比价</div>
						<a class="gzwb" target="_blank" href="//www.yaofangwang.com/app/index.html">扫码下载</a>
				</div>
		</div>
		<div class="i i4">
			<span class="iconfont icon-jianyi"></span>
			<a class="t" href="//www.yaofangwang.com/suggest.html" target="_blank">意见反馈</a>
			</div>
		<div class="i i5">
			<span cla="iconfont icon-jiantoushang"></span>
			<a class="t" href="javascript:void(0);">返回顶层</a>
		</div>
	</div> -->
  <div v-if="loading" v-loading="loading" element-loading-text="加载中..." style="min-height: 35vw;">
  </div>
  <div class="no-info" v-if="(!error)&&(!components.length)">
        <div class="no-data">
          <img src="../../../static/images/no-search.png">
          <br> 抱歉！暂时还没有商品
        </div>
  </div>
    <div class="no-info" v-if="error">
      <div class="no-data">
        <img src="../../../static/images/error.png">
        <br> 抱歉！出错了...
      </div>
    </div>

  </div>
</template>
<script>
  // import { productHome } from '/api/index.js'
  import Vue from 'vue'
  import YShelf from '/components/shelf'
  import product from '/components/product'
  import mallGoods from '/components/mallGoods'
  import plugins from '@/components/plugins/index'
  import { getParamByTempName } from '/api/goods.js'
  export default {
    data () {
      return {
        error: false,
        banner: [],
        mark: 0,
        bgOpt: {
          px: 0,
          py: 0,
          w: 0,
          h: 0
        },
        home: [],
        loading: true,
        dialogVisible: false,
        timer: '',
        goodsList: [],
        components: []
      }
    },
    created () {
      Object.keys(plugins).forEach(key => {
        let widget = plugins[key].widget
        // console.log('widget', widget)
        Vue.component(key, widget)
      })
    },
    mounted () {
      this._getParamByTemplate()
    },
    methods: {
      _getParamByTemplate () {
        const params = {
          template_name: 'pc',
          version: 'v1.0.1',
          page_name: 'index'
        }
        getParamByTempName(params).then(({data}) => {
          let list = data.list.map(item => {
            return item.params
          })
          this.components = list
          this.loading = false
        }).catch(() => {
          this.loading = false
          this.error = true
        })
      }
    },
    components: {
      YShelf,
      product,
      mallGoods
    }
  }
</script>
<style lang="scss" scoped>
 @import "../../assets/icon/iconfont.css";
  .home {
    display: flex;
    flex-direction: column;
    width:1220px;
    margin:0 auto;
  }

  .no-info {
    padding: 100px 0;
    text-align: center;
    font-size: 30px;
    display: flex;
    flex-direction: column;
    .no-data{
      align-self: center;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .page {
    position: absolute;
    width: 100%;
    top: 470px;
    z-index: 30;
    .dots {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .dot-active {
        display: inline-block;
        width: 15px;
        height: 15px;
        background-color: whitesmoke;
        border-radius: 8px;
        margin-right: 10px;
        cursor: pointer;
      }
      .dot {
        opacity: 0.2;
      }
    }
  }

  .activity-panel {
    width: 1220px;
    margin: 0 auto;
    .box {
      overflow: hidden;
      position: relative;
      z-index: 0;
      margin-top: 25px;
      box-sizing: border-box;
      border: 1px solid rgba(0,0,0,.14);
      border-radius: 8px;
      background: #fff;
      box-shadow: 0 3px 8px -6px rgba(0,0,0,.1);
    }
    .content {
      float: left;
      position: relative;
      box-sizing: border-box;
      width: 25%;
      height: 200px;
      text-align: center;
    }
    .content ::before{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      box-sizing: border-box;
      border-left: 1px solid #f2f2f2;
      border-left: 1px solid rgba(0,0,0,.1);
      width: 100%;
      height: 100%;
      content: "";
      pointer-events: none;
    }
    .i {
      width: 305px;
      height: 200px;
    }
    .cover-link {
      cursor: pointer;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 4;
      background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
    }
    a {
      color: #5079d9;
      cursor: pointer;
      transition: all .15s ease-out;
      text-decoration: none;
    }
    a:hover {
      box-shadow: inset 0 0 38px rgba(0,0,0,.08);
      transition: all .15s ease;
    }
  }

  .banner, .banner span, .banner div {
    font-family: "Microsoft YaHei";
    transition: all .3s;
    transition-timing-function: linear;
  }

  .banner {
    cursor: pointer;
    perspective: 3000px;
    position: relative;
    z-index: 19;
    margin: 0 auto;
    width: 1220px;
  }

  .bg {
    position: relative;
    width: 1220px;
    height: 500px;
    margin: 20px auto;
    background-size: 100% 100%;
    border-radius: 10px;
    transform-style: preserve-3d;
    transform-origin: 50% 50%;
    transform: rotateY(0deg) rotateX(0deg);
    & div{
      position: relative;
      height: 100%;
      width: 100%;
    }
  }

  .img1 {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    border-radius: 10px;
  }

  .img2 {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 5px;
    left: 0;
    background-size: 95% 100%;
    border-radius: 10px;
  }

  .img3 {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    border-radius: 10px;
  }

  .a {
    z-index: 20;
    transform: translateZ(40px);
  }

  .b {
    z-index: 20;
    transform: translateZ(30px);
  }

  .c {
    transform: translateZ(0px);
  }

  .sk_item {
    width: 170px;
    height: 225px;
    padding: 0 14px 0 15px;
    > div {
      width: 100%;
    }
    a {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transition: all .3s;
      &:hover {
        transform: translateY(-5px);
      }
    }
    img {
      width: 130px;
      height: 130px;
      margin: 17px 0;
    }
    .sk_item_name {
      color: #999;
      display: block;
      max-width: 100%;
      _width: 100%;
      overflow: hidden;
      font-size: 12px;
      text-align: left;
      height: 32px;
      line-height: 16px;
      word-wrap: break-word;
      word-break: break-all;
    }
    .sk_item_price {
      padding: 3px 0;
      height: 25px;
    }
    .price_new {
      font-size: 18px;
      font-weight: 700;
      margin-right: 8px;
      color: #f10214;
    }
    .price_origin {
      color: #999;
      font-size: 12px;
    }
  }

  .box {
    overflow: hidden;
    position: relative;
    z-index: 0;
    margin-top: 29px;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, .14);
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 3px 8px -6px rgba(0, 0, 0, .1);

  }

  ul.box {
    display: flex;
    li {
      flex: 1;
      img {
        display: block;
        width: 305px;
        height: 200px;
      }
    }
  }

  .mt30 {
    margin-top: 30px;
  }

  .hot {
    display: flex;
    > div {
      flex: 1;
      width: 25%;
    }
  }

  .floors {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .imgbanner {
      width: 50%;
      height: 430px;
      .cover-link {
        cursor: pointer;
        display: block;
        position: absolute;
        top: 60px;
        left: 0;
        width: 50%;
        height: 430px;
        z-index: 4;
        background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
      }
      .cover-link:hover {
        box-shadow: inset 0 0 38px rgba(0,0,0,.08);
        transition: all .15s ease;
      }
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
	.slidenav {
    position: fixed;
    right: 2px;
    top: 233px;
    background: #fff;
    width: 52px;
    z-index: 9997;
    display: none;
		-webkit-transform: translateZ(0);
		font-size:12px;
}

.slidenav .i {
    display: block;
    height: 50px;
    width: 50px;
    border: 1px solid #e5e5e5;
    border-bottom: 0;
    padding: 10px;
    text-decoration: none;
		position: relative;
		display:flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		.iconfont{
			display: block;
			font-size:20px;
		}
		.desc{
			display:none;
		}
		&:hover{
			.iconfont{
				display:none;
			}
			.desc{
				display:block;
			}
		}
}

.slidenav .i.last {
    border-bottom: 1px solid #e5e5e5
}

.slidenav .i i {
    display: none;
    width: 20px;
    height: 20px;
    line-height: 20px;
    background: #e50000;
    color: #fff;
    text-align: center;
    border-radius: 20px;
    position: absolute;
    right: 5px;
    top: 5px;
    font-style: normal;
    font-size: 12px;
    font-family: Arial;
    opacity: .8
}

.slidenav .i.hover i {
    opacity: 0
}

.slidenav .i.i1 {
    background-position: -91px -308px;
    background-color: #0cb95f;
    border-color: #0cb95f
}

.slidenav .i.i2 {
    background-position: -138px -307px
}

.slidenav .i.i3 {
    background-position: -188px -307px
}

.slidenav .i.i4 {
    background-position: -236px -307px
}

.slidenav .i.i5 {
    background-position: -284px -307px;
    display: none
}

.slidenav .i.i6 {
    background-position: -335px -307px
}

.slidenav .i.i6.hover {
    border-top: 1px solid #fff
}

.slidenav .i .contact {
    position: absolute;
    right: 51px;
    top: -1px;
    display: none;
    font-size: 0;
    padding-right: 10px
}

.slidenav .i .contact .qqcon {
    background: #0cb95f;
    padding: 8px;
    width: 126px
}

.slidenav .i .contact .qqcon p {
    color: #fff;
    line-height: 1;
    font-size: 12px;
    position: relative
}

.slidenav .i .contact .qqcon .js {
    height: 35px;
    background: #fff;
    padding: 10px 0;
    text-align: center;
    margin-top: 8px
}

.slidenav .i .contact .qqcon .js a {
    display: block
}

.slidenav .i .contact .qqcon .js a img {
    width: 110px;
    height: 34px;
    vertical-align: top
}

.slidenav .i .contact .qqcon p img {
    position: absolute;
    top: -4px;
    right: 2px;
    cursor: pointer;
    height: 20px;
    width: 20px
}

.slidenav .i .contact .qqcon .js+img {
    height: 90px;
    width: 100%;
}

.slidenav .i .gzwm {
    position: absolute;
    right: 51px;
    top: -103px;
    background: #fff;
    padding: 15px 20px;
    border: 1px solid #e5e5e5;
    color: #333;
    border-right: 0;
    white-space: nowrap;
    line-height: 24px;
    width: 155px;
    display: block;
    height: 198px;
    width: 90px;
    text-align: center;
    display: none
}

.slidenav .i .gzwm .wxsbg {
    width: 80px;
    height: 80px;
    margin-bottom: 5px
}

.slidenav .i .gzwm .wbsbg {
    width: 28px;
    height: 24px;
    margin-top: 10px;
    margin-bottom: 10px;
    background-position: -364px -234px
}

.slidenav .i .gzwm .gzwb {
    background: #ee7076;
    color: #fff;
    width: 66px;
    display: block
}

.slidenav .i.i3.hover .gzwm {
    display: block
}

.slidenav .i.i7 {
    background-position: -121px -358px
}

.slidenav .i .app {
    position: absolute;
    right: 51px;
    top: -103px;
    background: #fff;
    padding: 15px 20px;
    padding-top: 32px;
    border: 1px solid #e5e5e5;
    color: #333;
    border-right: 0;
    white-space: nowrap;
    line-height: 24px;
    width: 155px;
    display: block;
    height: 156px;
    width: 90px;
    text-align: center;
    display: none
}

.slidenav .i .app .appbg {
    width: 80px;
    height: 80px;
    margin-bottom: 5px
}

.slidenav .i .app .gzwb {
    background: #0cb95f;
    color: #fff;
    width: 75px;
    display: block;
    margin-top: 5px
}

.slidenav .i.i7.hover .app {
    display: block
}

.slidenav .i .t {
    display: none;
    height: 30px;
    width: 30px;
    text-align: center;
    text-decoration: none;
    cursor: pointer
}

.slidenav .i.hover {
    background-color: #0cb95f;
    color: #fff;
    border-color: #0cb95f
}

.slidenav .i.hover .t {
    display: block;
    background: #0cb95f;
    color: #fff;
    border-color: #0cb95f
}

.slidenav-left {
    position: fixed;
    left: 5px;
    top: 234px;
    width: 118px;
    z-index: 99999;
    display: none;
    height: 238px
}

.slidenav-left .c {
    position: absolute;
    right: 8px;
    top: 24px;
    background-position: -357px -14px;
    display: block;
    height: 14px;
    width: 14px
}
</style>



// WEBPACK FOOTER //
// home.vue?0e85371c